import React, { useContext } from "react";
import {
  Box,
  Button,
  Heading,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  HStack,
  useRadioGroup,
  Text,
  Flex,
  Image,
  VStack,
  StackDivider,
  Divider,
  Select,
  useToast,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { ITEContext } from "../../../context/ITEContext";
import IconCardXL from "../../layouts/IconCardXL";
import Counter from "../../../assets/Counter";
import Picto1 from "../Step1/picto1/Picto1.png";
import Picto2 from "../Step3/picto1/Picto1.png";
import Picto3 from "../Step3/picto1/Picto2.png";
import Picto4 from "../Step3/picto1/Picto3.png";
import RadioCard from "../../layouts/RadioCard";
import itepicto from "./itepicto.png";
import axios from "axios";

const StepOneITE = ({ onNext, onBack }) => {
  const { formDataITE, setFormDataITE, defaultFormDataITE } = useContext(ITEContext);
  const toast = useToast();
  const navigate = useNavigate();

  // Calcul du coût du projet : 240 x superficieMur
  const coutProjetITE = formDataITE.superficieMur ? 240 * Number(formDataITE.superficieMur) : 0;

  // Calcul des économies sur 10 ans : 30% de depenseChauffage x 10
  const economies10ansITE = formDataITE.depenseChauffage ? Math.round(0.3 * Number(formDataITE.depenseChauffage) * 10) : 0;

  const calculateMaPrimeITE = () => {
    const color = (formDataITE.aideColor || '').toLowerCase();
    let montant = 0;
    let bareme = 0;
    if (color === 'bleu') bareme = 75;
    else if (color === 'jaune') bareme = 60;
    else if (color === 'violet') bareme = 40;
    else return 0; // violet ou autre = non éligible

    const surface = Math.min(Number(formDataITE.superficieMur) || 0, 100);

    montant = bareme * surface;

    return montant;
  };

  formDataITE.maPrimeRenovITE = calculateMaPrimeITE();

  const calculateAidesCeeITE = () => {
    const color = (formDataITE.aideColor || '').toLowerCase();
    let bareme = 0;
    if (color === 'bleu') bareme = 11;
    else if (color === 'jaune' || color === 'violet' || color === 'rose') bareme = 10;
    const surface = Math.min(Number(formDataITE.superficieMur) || 0, 100);
    return bareme * surface;
  };

  formDataITE.aidesCeeITE = calculateAidesCeeITE();

  const handleSaveITE = () => {
    const commercialName = localStorage.getItem("name");
    const clientITEData = {
      ...formDataITE,
      commercial: commercialName,
      coutProjetITE: coutProjetITE,
      economies10ansITE: economies10ansITE,
      dateSaved: new Date(),
    };

    axios
      .post(`${process.env.REACT_APP_SERVER_URL}/clientsITE`, clientITEData)
      .then((response) => {
        toast({
          title: "Succès.",
          description: "L'étude ITE a été enregistrée avec succès.",
          status: "success",
          duration: 2000,
          isClosable: true,
        });
        setTimeout(() => {
          navigate("/ite");
        }, 1200);
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde de l'étude ITE:", error);
        toast({
          title: "Erreur.",
          description: "Une erreur s'est produite lors de l'enregistrement de l'étude ITE.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      });
  };

  return (
    <Box width="full" minH="100vh" position="relative" overflow="hidden">
      {/* Image de fond floutée */}
      <Box
        position="absolute"
        top={0}
        left={0}
        w="100%"
        h="100%"
        zIndex={0}
        overflow="hidden"
      >
        <img
          src={itepicto}
          alt="ITE background"
          style={{
            width: '100vw',
            height: '100vh',
            objectFit: 'cover',
            filter: 'blur(10px) brightness(0.85)',
            position: 'absolute',
            top: 0,
            left: '-8vw',
          }}
        />
      </Box>

      {/* Contenu centré par-dessus */}
      <Flex
        justify="center"
        align="center"
        minH="100vh"
        position="relative"
        zIndex={1}
      >
        <Box
          w={["95vw", null, "400px"]}
          bgColor="white"
          borderRadius="16px"
          border="1px solid"
          borderColor="#F4F4F4"
          overflow="hidden"
          boxShadow="0 4px 20px rgba(0, 0, 0, 0.12)"
          transition="all 0.3s"
          p={0}
        >
          {/* Header simple */}
          <Box
            bgColor="#30C9FF"
            p={6}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Text
              fontSize="18px"
              fontWeight="600"
              color="white"
              textAlign="center"
            >
              Résultats ITE
            </Text>
          </Box>

          {/* Contenu */}
          <Box p={8}>
            <VStack
              divider={<StackDivider borderColor="#F4F4F4" />}
              align="stretch"
              w="full"
              spacing={4}
            >
              <Flex justifyContent="space-between" align="center" py={3}>
                <Text fontSize="14px" color="#8C8C8C" fontWeight="500">
                  Coût du projet
                </Text>
                <Text fontSize="16px" fontWeight="700" color="#2D3748">
                  {coutProjetITE.toLocaleString()} €
                </Text>
              </Flex>

              <Flex justifyContent="space-between" align="center" py={3}>
                <Text fontSize="14px" color="#8C8C8C" fontWeight="500">
                  Aide CEE
                </Text>
                <Text fontSize="16px" fontWeight="700" color="#2D3748">
                  {formDataITE.aidesCeeITE.toLocaleString()} €
                </Text>
              </Flex>

              <Flex justifyContent="space-between" align="center" py={3}>
                <Text fontSize="14px" color="#8C8C8C" fontWeight="500">
                  Économies 10 ans
                </Text>
                <Text fontSize="18px" fontWeight="700" color="#2D3748">
                  {economies10ansITE.toLocaleString()} €
                </Text>
              </Flex>
            </VStack>
          </Box>
        </Box>
      </Flex>

      {/* Bouton Back en haut à droite */}
      <Box position="absolute" top={6} right={10} zIndex={2}>
        <Button
          w="120px"
          bgColor="white"
          color="#30C9FF"
          fontWeight="600"
          borderRadius="8px"
          border="1px solid"
          borderColor="#30C9FF"
          _hover={{
            bgColor: "#30C9FF",
            color: "white",
            transform: "translateY(-2px)",
            transition: "all 0.2s",
          }}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>

      {/* Bouton Enregistrer l'étude en bas à droite */}
      <Box position="fixed" bottom={8} right={10} zIndex={2}>
        <Button
          w="180px"
          bgColor="#30C9FF"
          color="white"
          fontWeight="600"
          borderRadius="8px"
          boxShadow="0 2px 8px rgba(48,201,255,0.15)"
          _hover={{
            bgColor: "#1899D6",
            boxShadow: "0 4px 16px rgba(48,201,255,0.18)",
            transform: "translateY(-2px)",
            transition: "all 0.2s",
          }}
          onClick={handleSaveITE}
        >
          Enregistrer l'étude
        </Button>
      </Box>
    </Box>
  );
};

export default StepOneITE;
